"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const navigation = require("next/navigation");
const client = require("@prismicio/client");
async function redirectToPreviewURL(config) {
  const { client: client$1, request, linkResolver, defaultURL = "/" } = config;
  const { cookies, draftMode } = await import("next/headers");
  const documentID = request.nextUrl.searchParams.get("documentId") ?? void 0;
  const previewToken = request.nextUrl.searchParams.get("token") ?? void 0;
  if (previewToken) {
    const cookieJar = await cookies();
    cookieJar.set(client.cookie.preview, previewToken);
  }
  const previewURL = await client$1.resolvePreviewURL({
    documentID,
    previewToken,
    defaultURL,
    linkResolver
  });
  (await draftMode()).enable();
  navigation.redirect(previewURL);
}
exports.redirectToPreviewURL = redirectToPreviewURL;
//# sourceMappingURL=redirectToPreviewURL.cjs.map
